import { MonitorSmartphone } from "lucide-react";

export function EmptyFiles({ label }: { label: string }) {
  return (
    <div className="flex min-h-32 flex-col items-center justify-center gap-3 rounded-lg border border-neutral-200 bg-neutral-50 px-6 text-center text-neutral-500">
      <MonitorSmartphone size={22} />
      <p className="max-w-72 text-sm leading-6">{label}</p>
    </div>
  );
}
